export enum MixedGroupedOddsOutrightsTabSelected {
    Odds = 'odds',
    Outrights = 'outrights',
}
